import { useContext, useEffect, useState } from 'react';
import { OnboardingContext } from '../modules/Onboarding/states/OnboardingProvider';

export const useOnboardingWidgetHeight = (): number => {
  const { state } = useContext(OnboardingContext);
  const [onboardingWidgetHeight, setOnboardingWidgetHeight] = useState<number>(0);

  useEffect(() => {
    const currentElement = state.ref.current;
    if (!currentElement) {
      setOnboardingWidgetHeight(0);
      return;
    }
    const expanded = state.expanded;

    const resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        setOnboardingWidgetHeight(entry.contentRect.height);
      }
    });

    if (expanded) {
      resizeObserver.observe(currentElement);
    } else {
      resizeObserver.unobserve(currentElement);
      const title = currentElement.querySelector('#onboardingTitleWrapper');
      const titleHeight = title ? title.clientHeight : 0;
      setOnboardingWidgetHeight(titleHeight);
    }

    return () => {
      resizeObserver.unobserve(currentElement);
      resizeObserver.disconnect();
    };
  }, [state.ref, state.expanded]);

  return onboardingWidgetHeight;
};
